<template>
    <div style="background:white" class="ve-list-page">
        <div style=" background:white;line-height:30px;border-bottom:2px solid #389"> 
            <div style="padding-top:3px;display:flex;width:1400px; ">
                <div style="width:90px">
                    <i class="iconfont icon-a-baobiaoguanlibaobiao" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:8px;"></i>
                    <el-link :disabled="addBool" @click="repShow" :underline="false" style="margin-top:0px;"><span style="font-size:13px; ">{{ $LANG('0325', '报表') }} </span></el-link>
                </div>
 
                <span style=" margin-left:10px;font-size:12px;margin-right:10px;">{{ $LANG('0681', '字段查询') }}</span>
                <el-select v-model="selparam" size="small" :placeholder="$LANG('1675', '请选择列名')" clearable  style="width:150px; " >
                    <span v-for="item in poCol" :key='item.key'>
                        <el-option :label="item.title" :value="item.key" v-if="item.thide=='N' "></el-option>
                    </span>
                </el-select>
                <el-input :placeholder="input_hold" v-model="txtparam" @keyup.enter.native="stfgChange" size="small" style="width:320px; height:30px; ">
                    <el-select v-model="oper" slot="prepend"   style="width:100px; " >
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                        </span>
                    </el-select>
                    <el-button size="small" slot="append" icon="el-icon-search" @click="stfgChange" ></el-button>
                </el-input> 
                <el-select v-model="selparam2" size="small" :placeholder="$LANG('1675', '请选择列名')" clearable  style="width:150px;margin-left:4px" >
                    <span v-for="item in poCol" :key='item.key'>
                        <el-option :label="item.title" :value="item.key" v-if="item.thide=='N'"></el-option>
                    </span>
                </el-select>
                <el-input :placeholder="input_hold" v-model="txtparam2" @keyup.enter.native="stfgChange" size="small" style="width:320px; height:30px; ">
                    <el-select v-model="oper2" slot="prepend"   style="width:100px; " >
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                        </span>
                    </el-select>
                    <el-button size="small" slot="append" icon="el-icon-search" @click="stfgChange" ></el-button>
                </el-input>
                <el-link  @click="expExcel" :underline="false">
                    <i class="iconfont icon-daochu1" style="font-size:14px;  margin-left:10px;color:#409eff"></i>
                    <span style="font-size:11px;  font-weight:600;margin-left:5px;">{{ $LANG('0171', '导出EXCEL') }}</span>
                </el-link>
                <i class="iconfont icon-ziyuan" style="color:#409EFF;font-size:14px;margin:0 5px 0 15px;"></i>
                <el-link @click="openFieldSettingsDialog().catch(() => {})" :underline="false"><span style="font-size:12px;margin-right:15px;">{{ $LANG('0683', '字段设置') }}</span></el-link>
            </div>
        </div>
        <div class="ve-list-page__table">
        <ve-table :columns="vueCol"
            :table-data="poData"
            :columnHiddenOption="columnHiddenOption"
            :border-around="true"
            :border-x="true"
            :border-y="true"
            :fixed-header="true"
            row-key-field-name="IDSEQ"
            :row-style-option="rowStyleOption"
            :cell-style-option="cellStyleOption"
            :max-height="subHeight"
            :virtual-scroll-option="virtualScrollOption"
            :scroll-width="0"
            :column-width-resize-option="columnWidthResizeOption"
            :clipboardOption="{copy:true,paste:false,cut:false,delete:false}"
            :cellSelectionOption="{enable: false}"
            ref="refreq"
            v-loading="loading"
            :element-loading-text="$LANG('1959', '加载中')"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(255, 251, 255, 0.8)">
        </ve-table>
        </div>
        <VeColumnConfigDialog
            :visible="fieldSettingDialog.visible"
            :rows="fieldSettingDialog.rows"
            :loading="fieldSettingDialog.loading"
            :error="fieldSettingDialog.error"
            :locked-field-keys="fieldSettingDialog.lockedFieldKeys"
            :drag-group-field="fieldSettingDialog.dragGroupField"
            :language="$store.state.lang"
            @update:visible="fieldSettingDialog.visible = $event"
            @change="updateFieldSettingsDraft"
            @confirm="saveFieldSettingsDialog"
            @reset="resetFieldSettingsDialog"
            @close="closeFieldSettingsDialog"
        />
        <!-- 分页查询 -->
        <div style="margin-top: 5px; overflow: hidden;display:flex;background:white;font-size:12px" class="ve-list-page__pagination">
            <div style="float: left;padding-left:4px;font-size:12px;">
                <Page :total="dataCount" :page-size="rowSize" show-total :current="current" @on-change="changePage"></Page>
            </div>
            <div style="line-height:30px;height:35px;width:500px;display:flex ; ">
                <div style="color:#606266; font-size:12px;width:35px;margin-left:15px">{{ $LANG('0349', '每页') }}</div>
                <el-select v-model="rowSize" size="small" style="width:70px;"  @change="initPage">
                    <el-option 
                        v-for="item in pageList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
                <div style="color:#606266; margin-left:10px;font-size:12px;width:30px;">{{ $LANG('0398', '跳至') }}</div>
                <el-input v-enter-number size="small" v-model="goPage" style="width:50px;"></el-input> 
                <span style="color:#606266; font-size:12px;margin-left:4px">{{ $LANG('1660', '页') }}</span>
                <el-button @click="goNext" size="small" type="primary" style="width:40px;margin-left:15px;height:32px;">GO</el-button>
            </div>
        </div>
        <!-- 提示框 -->
        <el-dialog :show-close="false" :visible.sync="promptWin" width="400px" append-to-body :close-on-click-modal="false" :close-on-press-escape="false" >
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'35px'}">
                <span style="line-height:35px;height:35px;font-size:14px;padding-left:5px;">{{ $LANG('1442', '提示') }}</span>
            </div>
            <div style="line-height:30px;display:flex">
                <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
            </div>
            <div slot="footer">
                <Button type="primary"   @click="promptWin=false" style="margin-right:20px;">{{ $LANG('1638', '确定') }}</Button>
            </div>
        </el-dialog>
        <!-- 新增、编辑表单 -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="addWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:36px;height:36px;font-size:15px;padding-left:5px;"><i class="iconfont icon-xuanze" style="margin-right:5px"></i>{{$route.meta.title}} ：{{ $LANG('0109', '明细资料') }}</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <Form :model="poRow" :label-width="110" ref="dtlform"  label-position="right" inline  :rules="ruleValidate">  
                    <span v-for="(item,index) in poCol" :key="index" >
                        <FormItem   :label="item.title"  :class=" item.edcss=='textarea'?'item-one':'item-width'" v-if="item.fhide==='N'" :prop="item.key"  >                  
                            <el-date-picker size="small" :disabled="saveFlag" type="date"  v-if="item.edcss==='date'" v-model="poRow[item.key]" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                            <el-input-number size="small" :disabled="saveFlag||item.disabled==='Y'" :precision="item.dotnum"  v-else-if="item.edcss==='number'" v-model="poRow[item.key]" style="width:100%" ></el-input-number>   
 
 
                            <el-select size="small" :disabled="saveFlag" v-else-if="item.edcss==='select'" v-model="poRow[item.key]"   style="width:100%">
                                <el-option v-for="(item,index) in comboArr[item.key]" :key="index" :label="item.CNAME" :value="item.CODE"></el-option>
                            </el-select>
                            <el-input resize="none" :disabled="saveFlag" v-else-if="item.edcss==='textarea'" type="textarea" :rows="4"  :placeholder="$LANG('1670', '请输入内容')" v-model="poRow[item.key]" maxlength="1000" show-word-limit ></el-input>
                            <el-input size="small" :placeholder="item.holder" :disabled="saveFlag ||item.disabled==='Y'?true:false" type="text" v-else   v-model="poRow[item.key]" ></el-input>
                        </FormItem>
                    </span>
                </Form>
 
 
            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; " >
                <span style="float:right">
                    <i class="web-font" style="font-size:14px;margin-right:20px;color:#ed4014;font-weight:600"> {{ $LANG('1496', '提示：单据审核后不能再编辑 ， 如需编辑请弃审') }}</i>
                    <span style="margin-right:30px">
                        <i v-if="poRow['STFG']==='N'" style="margin-left:20px; color:red;font-size:28px; " class="iconfont icon-weishenhe3"> </i>
                        <i v-else-if="poRow['STFG']==='Y'" style="margin-left:20px; color:red;font-size:28px; " class="iconfont icon-yishenhe1"> </i>
                        <i v-else-if="poRow['STFG']==='X'" style="margin-left:20px; color:red;font-size:28px; " class="iconfont icon-yizuofei"> </i>
                    </span>
                    <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="addWin=false" style="margin-right:25px;">{{ $LANG('0132', '取消') }}</el-button>
                    <el-button :disabled="addBool||saveFlag"  type="primary" size="small" icon="iconfont icon-baocun"  @click="saveRec" style="margin-right:10px;">{{ $LANG('0130', '保存') }}</el-button>
                </span>
            </div>
        </el-dialog>
         <!-- 引用选择框 -->
        <el-dialog  v-dialogDrag   :visible.sync="btnWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0997', '选择记录') }}</span>
            </div> 
            <pub-win v-bind:tabCol ="tableCol"  v-bind:v_table="v_table" v-bind:v_key2="v_key2" v-bind:v_value2="v_value2" @child-exit="btnWin=false" @child-sure="btnSure"></pub-win>                
        </el-dialog>
        <!-- report preview -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="repWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0063', '报表预览') }}</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <iframe :src="repUrl" frameborder="0" style="width: 100%; height: 100%"></iframe>
            </div>
        </el-dialog>
 
    </div>
</template>
<script>
import {getBaseData,getTabColOrData} from '../../api/user'; 
import { getDate} from '../../api/Select' 
import pubWin from '../datamgt/pubwin.vue'  
import repWin from '../datamgt/repWin.vue' 
import createVeTableFieldSettingMixin from '@/utils/veTableFieldSettingMixin'
import VeColumnConfigDialog from '@/components/VeTable/VeColumnConfigDialog.vue'
import VeTableQueryHeader from '@/components/VeTable/VeTableQueryHeader.vue'
import { buildVeTableFieldCondition, buildVeTableHeaderCondition } from '@/utils/veTableHeaderQuery'
export default {
    name:'sup_list',
    mixins: [
        createVeTableFieldSettingMixin({
            settingFormId: '412741',
            fieldIdseq: '412741',
            fieldLstseq: '1',
            mainColumnKey: 'poCol',
            tableColumnKey: 'vueCol',
            initColumnKey: 'initCol',
            tableRef: 'refreq',
            generatedFixedColumnKeys: ['rownum', 'index', 'oper'],
        })
    ],
    data () {
        return {
            sendVal:'PRD',
            v_table:'',
            tableCol :[],
            v_key2 :'',
            v_value2 :'',
            toolFlag:false,
            qryCond:'',
    
            dtlRow:{},
            v_tabRow:{},
            v_tabIndex:'',
            chkIndex: 0,
            stfgBool:true,
            appBool:false,
            v_commit :true,
            promptWin:false,
  
            dtlFlag:'create',
            prdRow:{},
            supFlag:'',
            addFlag:'create',
 
            rowDtl:{},
            btnWin:false,
            stfgSet:'ALL',
 
            prompt:'',
            input_hold:this.$LANG('1670', '请输入内容')+'...',
            ruleValidate:{},
            selparam:'SUPNM',
            txtparam:'',
            poRow:{},
            prdFlag:'create',
            goPage:'',
            rowIdseq:'',
            poData:[],
            cfmBool:false, //审核 权限
            addBool:false, //新增 权限
            editBool:false, //编辑权限
            v_admin:this.$cookies.get('v_admin') , 
            loading:false,
            current:1,
            saveFlag:false,
            allList:[], //询价单集合
            dtlData:[],
            matData:[],
            addWin:false,
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') , //员工公司ID
            v_url:'xuper_auth/getTableRecMany' , //api请求路径   
            pageList: [{
                value: 50,
                label: '50'
                }, {
                value: 100,
                label: '100'
            }],
            selparam2:'',
            txtparam2:'',
            oper2:'like',
            dataCount:0,
            rowSize:50,
     
            matCol:[],
            poCol:[],
            initCol:[],
            vueCol:[],
            columnHiddenOption: {
                defaultHiddenColumnKeys: [],
            },
            rowStyleOption: { clickHighlight: true },
            cellStyleOption: {
                headerCellClass: () => 'table-head-cell-class',
                bodyCellClass: () => 'table-body-cell-class1',
            },
            v_headerRow:{},
            queryRequestId:0,
            headerSortKey:'',
            headerSortOrder:'',
            virtualScrollOption: { enable: false },
            operArr:[],
            prcCol:[],
            prcData:[],
            prdIndex:'',
            oper:'like',
            v_key:'',
            v_idseq:this.$cookies.get('idseq'),
            dtlIndex:'',
            comboArr:[],
       
            v_usernm:this.$cookies.get('v_usernm'), //api 请求用户
            repWin:false,
            repUrl:'',
 
            v_idno:'',
            v_replist:[],
            repArr:[],
        }
    },
    components: {
      pubWin,  
      VeColumnConfigDialog,
 
    },
    computed: {
        subHeight: function() {
            return (window.innerHeight - 162) + 'px';
        }, 
        dtlHeight: function() {
            return (window.innerHeight - 290) + 'px';
        }, 
        tabWidth: function() {
            return (window.innerWidth - 140) + 'px';
        },
    },
    mounted () {
        //操作符
        getBaseData(this.v_url,'PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        }) 
 
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','412742','V_USER_MOD_REP','').then(res=>{
            this.repArr =res.result
        })
 
         //用户权限表
        getBaseData(this.v_url,'userno',this.v_username ,'frmidseq','412742','v_sys_user_priv','').then(res=>{           
            if (this.v_admin==='N') { //表示有权限控制
                let row =res.result[0]
                if (row.ISADD==='N'){ //新增
                    this.addBool=true
                }if (row.ISUPD==='N'){ //修改
                    this.editBool=true
                }if (row.ISDEL==='N'){ //删除
                    this.delBool=true
                }if (row.ISCFM==='N'){ //审核
                    this.cfmBool=true
                }if (row.ISEXP==='N'){ //确认
                    this.appBool=true
                }
            }
        })    
         //动态生成表单验证规则
        getTabColOrData(this.v_url,'v_sys_form_fld','idseq','412742','LSTSEQ','1','NOTNULL','Y').then((res) => {
            let ruleObj={}
            let ruleVal=[]
            this.notNull = res.result
            res.result.forEach(item => {
                let v_fldnm =this.$translate.getColTitle(item, this.$store.state.lang)
                let obj1={required:true,message:v_fldnm+this.$LANG('2051', '不能为空'),trigger: 'blur'}
                ruleVal =[]
                ruleVal.push(obj1)
                ruleObj[item.FLDNO]=ruleVal                  
            });
            this.ruleValidate =ruleObj
        });
    },
    created () {
        if (this.v_username){
            this.getTabCol() //表列集合
            this.getPoList('') //询价单主数据   
            this.comSelect() 
        }else{
            let routeUrl = this.$router.resolve({
                path: '/',
                query: {lang:this.LANG },
            });
            window.open(routeUrl.href, '_self'); 
        }
    },
    methods: {
        expExcel(){
            let cond_=[]
            cond_.push(this.selparam)
            cond_.push(this.oper)
            cond_.push(this.txtparam)  
            cond_.push(this.selparam2)
            cond_.push(this.oper2)
            cond_.push(this.txtparam2)  
            let url='xuper_auth/report/ExpExcel'+'&p_key=corpid&p_value='+this.v_corpid+'&p_idseq=412741&p_lstseq=1&p_table=V_BS_SUPQRY&p_cond='+cond_+'&p_filenm='+this.$LANG('0736', '合格供应商一览表')
            window.open(url, "_self", "height=500,width=500")
        },
        repShow(){
            this.repWin =true
            this.repUrl =this.$store.state.repUrl+ 'sup_list.cpt'+'&p_corpid='+this.v_corpid
        },
 
        btnSure(obj){
            Object.assign(this.poRow,{ORDNO:obj['IDNO'],MATNO:obj['MATNO'],MATNM:obj['MATNM'],MATDESC:obj['MATDESC'],REFORDSEQ:obj['IDSEQ'],REFORDITM:obj['LSTSEQ']})     
            this.btnWin =false
        },
        //动态赋值下拉框
        comSelect(){  
            this.$axios({
                method:'post', 
                url: 'xuper_auth/getBaseData' ,
                data:{p_table:'v_sys_form_fld',p_key:'idseq',p_value:'412742',p_cond:' and lstseq in (1,2)',p_key2:'edcss',p_value2:'select'},
            }).then(res =>{
                if (res.result.length>0){
                    for(let k=0;k<res.result.length;k++){
                        getBaseData('xuper_auth/getBaseData','parentno',res.result[k].COMBO ,'','','v_sys_base','').then(res2=>{
                            this.$set(this.comboArr, res.result[k].FLDNO, res2.result || [])
                        })
                    }
                }
            })  
        },
 
        //编辑记录
        editRec(row,val,index){
            if (val==='Y'){  //仅查看
                this.saveFlag=true
            }else{
                if (row.STFG==='Y'){
                    this.saveFlag=true
                }else{
                    this.saveFlag=false
                }   
            }
            this.addFlag='edit'
            this.poRow =JSON.parse(JSON.stringify(Object.assign(row,{IDSEQ:row.IDSEQ})))
            this.rowIdseq=row.IDSEQ
 
            this.addWin=true   
            this.v_commit =true   
        },
        //保存记录
        saveRec(){
            this.notNull.some(item=>{  //forEach 没找到跳出循环，some：return true 跳出lop ,every：return false 跳出
                if (!this.poRow[item.FLDNO] ){
                    this.stfgBool =false 
                    this.promptWin=true
                    this.prompt=this.$translate.getColTitle(item, this.$store.state.lang)+this.$LANG('2051', '不能为空')
                    return true
                }else{
                    this.stfgBool =true  
                }
            })
            //发起保存请求   
            if (this.stfgBool &&this.v_commit) { 
                this.v_commit =false
                let v_flag=false ,v_qty=false
                this.dtlData.forEach(item=>{
                    if (!item['MATNO']){
                        v_flag =true
                    }
                    if (!item['QTY']){
                        v_qty =true
                    }
                })
 
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/formOneSave',
                    data: {p_json:JSON.stringify(Object.assign(this.poRow,{CORPID:this.v_corpid })), p_table:'qc_hand',frmid:'412742'},
                }).then(res=>{      
                    if(res.result ==='OK')  {  
                        let idseq_ =res.idseq

                        this.addWin =false   
                        this.getPoList('')
                    }else{
                        this.promptWin=true
                        this.prompt=res.result
                    }        
                }) 
 
            }
        },
        //新增
        addRec(){
            this.addWin=true
            this.poRow={DTTM:getDate('day'),'IDSEQ':'',STFG:'N' }
            this.dtlData=[]
            this.saveFlag=false
            this.v_commit =true
        },
 
        getRowKey(row){
            return row.IDSEQ
        },
        getDtlKey(row){
            return row.index
        },
        tabRowClass({row,rowIndex}){  //为 table数据添加 index 字段
            row.index =rowIndex
        },
        rowClick(row){
            this.chkIndex =row.index
        },
 
        rowShow(){
            this.v_headerRow = {}
            this.headerSortKey = ''
            this.headerSortOrder = ''
            this.current = 1
            this.stfgChange()
        },
        sortHeaderColumn(column, edcss){
            const key = column && column.key
            if (!key) return
            if (this.headerSortKey === key) {
                this.headerSortOrder = this.headerSortOrder === 'asc' ? 'desc' : 'asc'
            } else {
                this.headerSortKey = key
                this.headerSortOrder = 'asc'
            }
            const direction = this.headerSortOrder === 'asc' ? 1 : -1
            const type = String(edcss || '').toLowerCase()
            this.poData.sort((left, right) => {
                const leftValue = left[key]
                const rightValue = right[key]
                if (leftValue === rightValue) return 0
                if (leftValue === null || leftValue === undefined || leftValue === '') return 1
                if (rightValue === null || rightValue === undefined || rightValue === '') return -1
                if (type === 'number') return (Number(leftValue) - Number(rightValue)) * direction
                if (type === 'date' || type === 'date2' || type === 'time') {
                    return (new Date(leftValue).getTime() - new Date(rightValue).getTime()) * direction
                }
                return String(leftValue).localeCompare(String(rightValue), undefined, { numeric: true }) * direction
            })
        },
        //状态查询
        stfgChange(){
            let cond_=buildVeTableHeaderCondition(this.initCol, this.v_headerRow)
            cond_+=buildVeTableFieldCondition(this.initCol, this.selparam, this.txtparam, this.oper)
            cond_+=buildVeTableFieldCondition(this.initCol, this.selparam2, this.txtparam2, this.oper2)
            if (this.stfgSet!=='ALL'){
               cond_=cond_+' and  stfg=\''+this.stfgSet+'\''
            }
            this.headerSortKey = ''
            this.headerSortOrder = ''
            this.current = 1
            this.getPoList(cond_)
        }, 
        goNext(){
            if (this.goPage){
                this.changePage(this.goPage)
                this.current =Number(this.goPage)
            }else{
                this.$alert(this.$LANG('1721', '请输入跳至页数'), this.$LANG('1442', '提示'), {
                    confirmButtonText: this.$LANG('1638', '确定'),
                    showClose:false,
                    type:'info'
                })
            }
        },
        //表格页面导航
        changePage(index){
            var _start = ( index - 1 ) * this.rowSize;
            var _end = index * this.rowSize
            this.current =index
            this.poData = this.allList.slice(_start,_end);
        },
        //初始化查询页条数
        initPage(){
            //产品明细
            this.dataCount =this.allList.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allList.length < this.rowSize){
                this.poData = this.allList          
            }else{
         
                if (this.current >1){
                    this.changePage(this.current)
                }else{
                    this.poData =this.allList.slice(0,this.rowSize) //返回选定元素的子数组，不包含结尾元素
                }
            }
            this.$nextTick(() => { //有固定列时 查询后重新布局
                const table = this.$refs.refreq
                if (table && typeof table.doLayout === 'function') table.doLayout()
            }) 
        },
 
        //查询界面
        getPoList(cond){
            const requestId = ++this.queryRequestId
            this.loading = true
            getTabColOrData(this.v_url,'V_BS_SUPQRY','','','CORPID',this.v_corpid,'','',cond ).then((res) => {
                if (requestId !== this.queryRequestId) return
                this.allList =res.result || []
                this.initPage()
            }).catch((error) => {
                if (requestId === this.queryRequestId) {
                    this.promptWin=true
                    this.prompt=error.message || this.$LANG('1641', '查询失败')
                }
            }).finally(() => {
                if (requestId === this.queryRequestId) this.loading = false
            })
        },
 
        //获取表列头字段  v-enter-number
        getTabCol(){
            var vm=this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','412741','lstseq','1','','',' order by sortby,lstseq' ).then((res) => {
                vm.initCol = res.result || []
                vm.initCol.filter(item => String(item.EDCSS || '').toLowerCase() === 'select' && item.COMBO).forEach(item => {
                    getBaseData('xuper_auth/getBaseData','parentno',item.COMBO,'','','v_sys_base','').then(comboRes => {
                        vm.$set(vm.comboArr, item.FLDNO || item.key, comboRes.result || [])
                    })
                })
                vm.loadInitialFieldSettings().then(() => {
                    const fieldRows = vm.sortFieldRows(vm.initCol)
                    vm.poCol = []
                    vm.vueCol = []
                    fieldRows.forEach(item => {
                        const title = vm.$translate.getColTitle(item, vm.$store.state.lang)
                        const headerSortable = item.key !== 'RN' && item.SORTABLE === 'N' && item.EDCSS !== 'checkbox'
                        vm.poCol.push({
                            title,
                            key: item.key,
                            align: item.align,
                            width: item.width,
                            thide: item.THIDE,
                            fhide: item.FHIDE,
                            edcss: item.EDCSS,
                            disabled: item.DISABLED,
                            dotnum: item.DOTNUM,
                            holder: item.HOLDER,
                            sortable: item.SORTABLE,
                        })
                        vm.vueCol.push({
                            field: item.key,
                            key: item.key,
                            title,
                            align: item.align,
                            width: Number(item.width) || 120,
                            thide: item.THIDE,
                            fhide: item.FHIDE,
                            disabled: item.DISABLED,
                            sortable: false,
                            ellipsis: { showTitle: true },
                            renderHeaderCell: ({column}) => <VeTableQueryHeader
                                title={column.title}
                                edcss={item.EDCSS}
                                value={this.v_headerRow[item.key]}
                                operator={this.v_headerRow[`#OPER${item.key}`]}
                                showDateOperator={false}
                                sortable={headerSortable}
                                sortOrder={this.headerSortKey === item.key ? this.headerSortOrder : ''}
                                options={String(item.EDCSS || '').toLowerCase() === 'select' ? (this.comboArr[item.key] || []) : []}
                                on-input={(value) => this.$set(this.v_headerRow, item.key, value)}
                                on-operator-change={(value) => this.$set(this.v_headerRow, `#OPER${item.key}`, value)}
                                on-title-click={() => {
                                    if (headerSortable) this.sortHeaderColumn(column, item.EDCSS)
                                }}
                                on-query={this.stfgChange}
                            />,
                            renderBodyCell: ({row}) => {
                                if (item.EDCSS === 'checkbox') {
                                    return <el-checkbox disabled true-label="Y" false-label="N" v-model={row[item.key]} style="width:100%">&nbsp;</el-checkbox>
                                }
                                return row[item.key]
                            },
                        })
                    })
                    vm.vueCol.unshift({
                        field: 'index',
                        key: 'rownum',
                        title: vm.$LANG('0310', '序号'),
                        width: 60,
                        align: 'center',
                        fixed: 'left',
                        disableResizing: true,
                        renderBodyCell: ({rowIndex}) => rowIndex + 1,
                        renderHeaderCell: ({column}) => <div><div style="margin-top:3px">{column.title}</div><el-link underline={false} on-click={this.rowShow} style="font-size:12px;color:#404eff;height:30px"><el-tooltip content={this.$LANG('0852', '清除条件')} effect="light"><i class="iconfont icon-shanchu1"></i></el-tooltip></el-link></div>,
                    })
                    vm.applyFieldSettingRows()
                })
            })
 
 
        },
    }
}
</script>
<style scoped lang="less">
    .item-width  {
        height:20px;
        width: 32%;
    }
    .item-one {
        width: 97%;
        height:88px;
    }
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 0 auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
</style>
<style lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px;
            color:rgb(11, 11, 59);
            font-size:12px;
            background:rebeccapurple;
        }
        td {
            padding: 5px ;
            font-size:11px;
        } 
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    //.el-dialog__headerbtn i { background:white;font-size: 20px;  }
    .el-table .success-row {
        color:#959997;
    }
    .el-table .cancel-row {
        color: #e00e66;
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb;
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
